import QRCodeStand from "../../../Assets/QRCodeStand.png";
import TagNFC from "../../../Assets/NFCCard.png";
import { INDIA_COUNTRY } from "../../CreditSetup/paymentCurrency.util";
/** Catalog for QR Code Kit shop (ids must match order line `itemId`). */
const QR_CODE_KIT_SHOP_ITEM_DEFS = [
	{
		id: 1,
		name: "QR Code Scanner",
		detail: {
			heading: "This item includess",
			points: [
				"PVC Stand",
				"NFC attached to PVC Stand",
				"QR code and design printed on PVC stand",
			],
		},
		priceUsd: 30,
		priceInr: 150,
		image: QRCodeStand,
	},
	{
		id: 2,
		name: "NFC Cards",
		detail: {
			heading:
				"Elegant waterproof NFC table cards for effortless restaurant reviews.",
			points: [],
		},
		priceUsd: 15,
		priceInr: 50,
		image: TagNFC,
	},
];

export const getQrCodeKitShopItems = (country) => {
	const isIndia = country === INDIA_COUNTRY;
	const currency = isIndia ? "inr" : "usd";

	return QR_CODE_KIT_SHOP_ITEM_DEFS.map((item) => ({
		id: item.id,
		name: item.name,
		detail: item.detail,
		image: item.image,
		price: isIndia ? item.priceInr : item.priceUsd,
		currency,
	}));
};

/** @deprecated Use getQrCodeKitShopItems(country) for country-aware pricing */
export const QR_CODE_KIT_SHOP_ITEMS = getQrCodeKitShopItems(null);
